import Vue from "vue";
import App from "./App.vue";
import router from "./router"; // ✅ Import Vue Router
import store from "./store";
import axios from "axios";

// Optional: import Bootstrap icons if used in App.vue
import "bootstrap-icons/font/bootstrap-icons.css";

// Optional: base CSS (you can remove if not using Bootstrap)
import "bootstrap/dist/css/bootstrap.min.css";

Vue.config.productionTip = false;
import ActionGuard from "@/plugins/ActionGuard";
import "@/assets/actionGuard.css";

import LocalDataService from "./plugins/localDataService";
Vue.use(LocalDataService); // 🧩 register professional plugin
Vue.use(ActionGuard);

// 🔐 Axios interceptor — ajoute le token sur chaque requête API
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("cafe_auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

new Vue({
  router, // ✅ Inject router
  store, // ✅ Inject Vuex store
  render: (h) => h(App),
}).$mount("#app");
